import React, { useState, useEffect } from 'react';

import Dialog, {
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText
} from 'material-ui/Dialog';

import Button from 'material-ui/Button';
import warningTriangle from '../images/warningTriangle.png';

const dialogContainer = {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 7,
    boxShadow:
        '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
    minwidth: '30vw',
    overflow: 'visible',
};

const dialogTextStyle = {
    textAlign: 'center',
};

const primaryDialogTextStyle = {
    textAlign: 'center',
    paddingBottom: '0.5em',
};

const dialogeTimerText = {
    fontSize: '1.5em',
    textAlign: 'center',
};

const RenderTimeoutDialog = (props) => {
    const [milliSeconds, setMilliSeconds] = useState(props.timeoutInterval);
    const [minutes, setMinutes] = useState(Math.floor(props.timeoutInterval / 60000));
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        let timeoutTimer;

        if (milliSeconds > 0 && props.open) {
            timeoutTimer = setTimeout(() => {
                setMilliSeconds(milliSeconds - 1000);

                if (seconds > 0) {
                    setSeconds(seconds - 1);
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }, 1000);
        } else if (props.open) {
            props.handleIdleTimeout();
        }

        return () => clearTimeout(timeoutTimer);
    });

    return (
        <Dialog
        open={props.open}
        aria-labelledby="timeout warning dialogue"
        PaperProps={{
          style: { ...dialogContainer }
        }}
        >
            <DialogContent>
                <img src={warningTriangle} alt="icon" className="warning-modal-icon" />
                <DialogTitle className="dialogHeaderStyle">
                    Your session is about to expire!
                </DialogTitle>
                <DialogContentText style={primaryDialogTextStyle}>
                    Don't worry though, you won't lose your work.
                </DialogContentText>
                <DialogContentText style={dialogTextStyle}>
                    You will be automatically signed out in
                </DialogContentText>
                <DialogTitle style={dialogeTimerText}>
                    {`${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`}
                </DialogTitle>
                <DialogContentText style={dialogTextStyle}>
                    To continue your session, click Stay Signed In.
                </DialogContentText>
            </DialogContent>

            <DialogActions className="time-out-btn-container">
                <Button
                    className="secondary-ghost-btn"
                    onClick={props.signOutAction}
                >
                Sign Out
                </Button>
                <Button
                    className="primary-solid-btn"
                    onClick={props.staySignedInAction}
                >
                Stay Signed In
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RenderTimeoutDialog;


// WEBPACK FOOTER //
// ./src/helpers/RenderTimeoutDialog.js